import { Drawer } from 'restaurantAdmin/components/drawer/Drawer';
import { Button, ButtonVariants } from '@components/button/Button';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { toShortMonthDayFormat } from '@shared/utils/dateFormatters';
import { ISOTimeTo12HourTime } from '@shared/utils/time';
import typography from '~styles/typography.scss';
import { useFetchReservationActivities } from '../hooks/useFetchReservationActivities';
import styles from './ActivityLogDrawer.scss';

interface ActivityLogDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  reservationId: string;
}

export const ActivityLogDrawer = ({
  isOpen,
  onClose,
  reservationId,
}: ActivityLogDrawerProps) => {
  const { timezone } = useRestaurant();
  const { data: activities } = useFetchReservationActivities(
    isOpen ? reservationId : null,
  );

  return (
    <Drawer modal={false} disablePointerDismissal side="right" open={isOpen}>
      <div className={styles.container}>
        <header className={styles.headerBar}>
          <h2 className={typography.h4}>Activity Log</h2>
          <Button
            label="Close"
            onClick={onClose}
            variant={ButtonVariants.Tertiary}
          />
        </header>

        <div className={styles.content}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>User</th>
                <th>Action Taken</th>
                <th>Time</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {activities?.map((activity) => (
                <tr key={activity.id}>
                  <td>{activity.name}</td>
                  <td>{activity.change}</td>
                  <td>{ISOTimeTo12HourTime(activity.time)}</td>
                  <td>{toShortMonthDayFormat(activity.date, timezone)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className={styles.footer}>No further activities logged.</p>
        </div>
      </div>
    </Drawer>
  );
};
